








































import { Component, Vue } from "vue-property-decorator";
import router from "@/router";
import { championTable, championDeck } from "@/store/index";
import { mdiStar } from "@mdi/js";

@Component({
  name: "champion-data-table",
  components: {}
})
export default class ChampionDataTable extends Vue {
  icon = { mdiStar };
  rating: number = 1;
  colors: string[] = ["green", "purple", "orange"];

  headers = [
    {
      text: "",
      align: "left",
      sortable: false,
      value: "image"
    },
    {
      text: "名前",
      align: "left",
      value: "name",
      width: "200px"
    },
    { text: "オリジン", value: "origin" },
    { text: "クラス", value: "class" },
    { text: "コスト", value: "cost" },
    { text: "HP", value: "hp" },
    { text: "DPS", value: "dps" },
    { text: "ダメージ", value: "damage" },
    { text: "攻撃速度", value: "attackSpeed" },
    { text: "物理防御", value: "armor" },
    { text: "魔法防御", value: "magicRegist" },
    { text: "射程", value: "range" },
    { text: "スキル", value: "skill" }
  ];
  genColor(i: number): string {
    return this.colors[i];
  }

  get search(): string {
    return championTable.searchWord;
  }
  set search(word: string) {
    championTable.setSearchWord(word);
  }

  get selectedLevel(): number {
    return championTable.selectLevel;
  }
  set selectedLevel(level: number) {
    championTable.selectChampionLevel(level);
  }

  get originList() {
    return Object.values(championDeck.originList);
  }
  get classList() {
    return Object.values(championDeck.classList);
  }

  toggleSelectOrigin(originId: string) {
    championTable.toggleSelectOrigin(originId);
  }

  toggleSelectClass(classId: string) {
    championTable.toggleSelectClass(classId);
  }
  isOriginSelected(originId: string): boolean {
    return championTable.selectOriginList.includes(originId);
  }

  isClassSelected(classId: string): boolean {
    return championTable.selectClassList.includes(classId);
  }

  created() {
    championTable.selectChampionLevel(1);
  }
  get championList() {
    let filteredChampionList = championTable.championTable;

    if (championTable.searchWord) {
      filteredChampionList = championTable.championTable.filter(
        x =>
          x.name.includes(this.search) ||
          x.id.toLowerCase().includes(this.search.toLowerCase())
      );
    }
    if (championTable.selectOriginList.length !== 0) {
      filteredChampionList = filteredChampionList.filter(x =>
        x.origin.some(o => championTable.selectOriginList.includes(o))
      );
    }
    if (championTable.selectClassList.length !== 0) {
      filteredChampionList = filteredChampionList.filter(x =>
        x.class.some(c => championTable.selectClassList.includes(c))
      );
    }
    return filteredChampionList;
  }

  selectLevel(level: number) {
    championTable.selectChampionLevel(level);
  }
}
